import {ICreateAppModalService} from "./i-create-app-modal.service";
import {Inject, Injectable} from "@angular/core";
import {IModalService, modalServiceInjectionToken} from "@zaeper/angular-dashboard-view-lib";
import {CreateAppModalComponent} from "./create-app-modal.component";
import {ICreateAppModalOptions} from "./i-create-app-modal.options";

@Injectable()
export class CreateAppModalService implements ICreateAppModalService {
  constructor(@Inject(modalServiceInjectionToken) private readonly _modalService: IModalService) {
  }

  public open(createAppModalOptions: ICreateAppModalOptions): void {
    this._modalService.open(CreateAppModalComponent, {
      styleClass: 'bg-white rounded-lg',
      header: "App erstellen",
      showHeader: true,
      closable: true,
      width: '900px',
      closeOnEscape: true,
      dismissableMask: true,
      data: createAppModalOptions
    })
  }
}
